declare const __TRANSLATION_VERSION__: number

import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import HttpBackend from 'i18next-http-backend'
import { loadLocalState } from '@/utils/storage'

i18n
  .use(HttpBackend)
  .use(initReactI18next)
  .init({
    fallbackLng: 'en',
    lng: loadLocalState('lang') ?? 'en',
    debug: false,
    backend: {
      loadPath: '/locales/{{lng}}/{{ns}}.json',
      queryStringParams: { v: __TRANSLATION_VERSION__ },
    },
    defaultNS: 'global',
    interpolation: {
      escapeValue: false,
    },
  })

export default i18n
